import classNames from "classnames";
import React, { useMemo } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { ReportFilters } from "@common/types/filters/reports";
import { formatColHeaderLabel, validDateLabel } from "./cellLabels.helper";

interface Props {
    label: string;
    isTitle?: boolean;
    filters: ReportFilters;
    stickyRightOffset?: number;
    columnId: string;
    headerCellRef?: React.MutableRefObject<any>;
}

export const CashFlowReportHeaderCell: React.FC<Props> = ({
    label,
    isTitle = false,
    filters,
    columnId,
    headerCellRef,
    stickyRightOffset,
}) => {
    const shortLabel = useMemo(
        () => formatColHeaderLabel(filters, label),
        [label, filters],
    );
    const fullLabel = useMemo(
        () => formatColHeaderLabel(filters, label, true),
        [label, filters],
    );

    const validLabel = useMemo(() => validDateLabel(label), [label]);

    const cell = <span>{shortLabel}</span>;

    const headerCellWithTooltip = <Tooltip content={fullLabel}>{cell}</Tooltip>;

    return (
        <th
            ref={headerCellRef}
            className={classNames("data-table__header-cell", {
                "data-table__header-cell--title": isTitle,
            })}
            style={{
                ...(stickyRightOffset && {
                    right: stickyRightOffset,
                }),
                ...(columnId === "percent" && {
                    paddingRight: "0",
                }),
            }}
        >
            {validLabel ? headerCellWithTooltip : cell}
        </th>
    );
};
